import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, switchMap, takeUntil } from 'rxjs/operators'

import { MAP_INCIDENT_TYPE_TO_URL_PREFIX } from '../constants'

import {
  addCommentError,
  addCommentSuccess,
  addReplyError,
  addReplySuccess,
  deleteCommentError,
  deleteCommentSuccess,
  editCommentError,
  editCommentSuccess,
  fetchCommentsError,
  fetchCommentsSuccess,
  saveCommunityUserError,
  saveCommunityUserSuccess,
} from './actions'
import {
  ADD_COMMENT_REQUEST_ASYNC,
  ADD_REPLY_REQUEST_ASYNC,
  COMMENTS_REQUEST_ASYNC,
  DELETE_COMMENT_REQUEST_ASYNC,
  EDIT_COMMENT_REQUEST_ASYNC,
  SAVE_NICKNAME_REQUEST_ASYNC,
  SET_REPORT_DATA,
  TOGGLE_COMMUNITY_TAB,
} from './constants'

const fetchCommentsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      SET_REPORT_DATA,
      COMMENTS_REQUEST_ASYNC.INITIATE,
      EDIT_COMMENT_REQUEST_ASYNC.SUCCESS,
      DELETE_COMMENT_REQUEST_ASYNC.SUCCESS,
      ADD_COMMENT_REQUEST_ASYNC.SUCCESS,
      ADD_REPLY_REQUEST_ASYNC.SUCCESS,
      SAVE_NICKNAME_REQUEST_ASYNC.SUCCESS,
      TOGGLE_COMMUNITY_TAB
    ),
    filter(() => !!state$.value.resolutioncenter?.reportComments?.reportData?.reportId),
    switchMap(() => {
      const { reportData, communityTab } = state$.value.resolutioncenter.reportComments
      return api.resolutionCenter
        .fetchReportComments(
          reportData.reportId,
          communityTab,
          MAP_INCIDENT_TYPE_TO_URL_PREFIX[reportData.reportType]
        )
        .pipe(
          map((response) => fetchCommentsSuccess(response)),
          catchError((error) => of(epicsErrorHandler(fetchCommentsError, error))),
          takeUntil(action$.pipe(ofType(COMMENTS_REQUEST_ASYNC.CANCEL)))
        )
    })
  )

const editCommentEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(EDIT_COMMENT_REQUEST_ASYNC.INITIATE),
    mergeMap((action) =>
      api.resolutionCenter
        .editReportComment(
          state$.value.resolutioncenter.reportComments.reportData.reportId,
          action.payload.commentId,
          { comment: action.payload.newText },
          MAP_INCIDENT_TYPE_TO_URL_PREFIX[
            state$.value.resolutioncenter.reportComments.reportData.reportType
          ]
        )
        .pipe(
          map((response) => editCommentSuccess(response)),
          catchError((error) => of(epicsErrorHandler(editCommentError, error))),
          takeUntil(action$.pipe(ofType(EDIT_COMMENT_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

const deleteCommentEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DELETE_COMMENT_REQUEST_ASYNC.INITIATE),
    mergeMap((action) =>
      api.resolutionCenter
        .deleteReportComment(
          state$.value.resolutioncenter.reportComments.reportData.reportId,
          action.payload.commentId,
          MAP_INCIDENT_TYPE_TO_URL_PREFIX[
            state$.value.resolutioncenter.reportComments.reportData.reportType
          ]
        )
        .pipe(
          map((response) => deleteCommentSuccess(response)),
          catchError((error) => of(epicsErrorHandler(deleteCommentError, error))),
          takeUntil(action$.pipe(ofType(DELETE_COMMENT_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

const addCommentEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(ADD_COMMENT_REQUEST_ASYNC.INITIATE),
    mergeMap((action) =>
      api.resolutionCenter
        .addReportComment(
          state$.value.resolutioncenter.reportComments.reportData.reportId,
          {
            comment: action.payload.text,
            isCommunity: state$.value.resolutioncenter.reportComments.communityTab,
          },
          MAP_INCIDENT_TYPE_TO_URL_PREFIX[
            state$.value.resolutioncenter.reportComments.reportData.reportType
          ]
        )
        .pipe(
          map((response) => addCommentSuccess(response)),
          catchError((error) => of(epicsErrorHandler(addCommentError, error))),
          takeUntil(action$.pipe(ofType(ADD_COMMENT_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

const addReplyEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(ADD_REPLY_REQUEST_ASYNC.INITIATE),
    mergeMap((action) =>
      api.resolutionCenter
        .addReportComment(
          state$.value.resolutioncenter.reportComments.reportData.reportId,
          {
            comment: action.payload.text,
            parentId: action.payload.commentId,
            isCommunity: state$.value.resolutioncenter.reportComments.communityTab,
          },
          MAP_INCIDENT_TYPE_TO_URL_PREFIX[
            state$.value.resolutioncenter.reportComments.reportData.reportType
          ]
        )
        .pipe(
          map((response) => addReplySuccess(response)),
          catchError((error) => of(epicsErrorHandler(addReplyError, error))),
          takeUntil(action$.pipe(ofType(ADD_REPLY_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

const saveCommunityUserEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(SAVE_NICKNAME_REQUEST_ASYNC.INITIATE),
    mergeMap((action) =>
      api.resolutionCenter.saveCommunityUser(action.payload.nickname).pipe(
        map((response) => saveCommunityUserSuccess(response)),
        catchError((error) => of(epicsErrorHandler(saveCommunityUserError, error))),
        takeUntil(action$.pipe(ofType(SAVE_NICKNAME_REQUEST_ASYNC.CANCEL)))
      )
    )
  )

export default combineEpics(
  fetchCommentsEpic,
  editCommentEpic,
  deleteCommentEpic,
  addCommentEpic,
  addReplyEpic,
  saveCommunityUserEpic
)
